import { connect } from 'react-redux';
import { App } from './App';

import { getAllContent } from './reducers/selectors';
import { fetchAllContent } from './actions';

interface IStateProps {
    content: any;
}
interface IDispatchProps {
    fetchAllContent: () => void;
}
export default connect<IStateProps, IDispatchProps, void>(
    (state: any) => ({
        content: getAllContent(state),
    }),
    {
        fetchAllContent,
    },
)(App);



// WEBPACK FOOTER //
// ./src/App.conn.tsx